import { useQuery } from '@tanstack/react-query'

import { fetchMinYear, MinYearResponse } from 'services/verticalsTablesApi'

interface UseMinYearQuery {
  verticalIndices: string
  currentQueryKey: string
}

export const useMinYearQuery = ({ verticalIndices, currentQueryKey }: UseMinYearQuery) => {
  const { data, isLoading } = useQuery<MinYearResponse | null>({
    queryKey: [currentQueryKey, verticalIndices],
    queryFn: () => (verticalIndices ? fetchMinYear(verticalIndices) : null),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000,
  })

  return {
    minYear: data?.minYear ?? null,
    isLoading,
  }
}
